import { type FC, type ReactComponentElement } from "react";

import { type Tab, Tabs } from "@snapchat/snap-design-system";

import { subTabsStyle, tabSelectedClassName } from "./InsightsSubTabs.styles";
import { TabContent } from "./shared";

interface InsightsSubTabsProps {
    children: ReactComponentElement<typeof Tab> | undefined | (ReactComponentElement<typeof Tab> | undefined)[];
    selectedIndex?: number;
    onTabSelected?: (index: number, lastIndex: number) => void;
}

export const InsightsSubTabs: FC<InsightsSubTabsProps> = ({ children, selectedIndex, onTabSelected }) => {
    return (
        <TabContent>
            <Tabs
                onTabSelected={onTabSelected}
                size="large"
                className={subTabsStyle}
                tabSelectedClassName={tabSelectedClassName}
                selectedIndex={selectedIndex}
            >
                {children}
            </Tabs>
        </TabContent>
    );
};
